import { useCallback, useEffect, useRef, useState } from 'react';

// Tipagem local para o sentinel caso não esteja presente no escopo global do TypeScript
interface WakeLockSentinelLocal {
  released: boolean;
  type: 'screen';
  release: () => Promise<void>;
  addEventListener: (type: string, listener: EventListenerOrEventListenerObject) => void;
}

type WakeLockStatus = {
  supported: boolean;
  active: boolean;
  requestWakeLock: () => Promise<boolean>;
  releaseWakeLock: () => Promise<void>;
};

/**
 * Hook para manter a tela do dispositivo ativa utilizando a Screen Wake Lock API.
 * Armazena a intenção do usuário no localStorage para persistência entre recarregamentos.
 */
export function useScreenWakeLock(): WakeLockStatus {
  // Desativado por enquanto a pedido do usuário
  return {
    supported: false,
    active: false,
    requestWakeLock: async () => false,
    releaseWakeLock: async () => {},
  };
}
